import React, { createContext, useContext, ReactNode } from 'react';
import { useNetworkStatus } from '@/hooks/use-network-status';

// Define context type
type OfflineContextType = {
  isOnline: boolean;
  connectionQuality: 'good' | 'poor' | 'unknown';
};

// Create context with default values
const OfflineContext = createContext<OfflineContextType>({
  isOnline: true,
  connectionQuality: 'unknown',
});

// Provider component
export const OfflineProvider = ({ children }: { children: ReactNode }) => {
  const networkStatus = useNetworkStatus();

  return (
    <OfflineContext.Provider value={networkStatus}>
      {children}
    </OfflineContext.Provider>
  );
};

// Custom hook for using the context
export const useOfflineStatus = () => useContext(OfflineContext);
